import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IconCalendarEvent, IconListCheck, IconArrowLeft } from "@tabler/icons-react";
import LayoutHR from "layouts/layout-hr";
import { URLS } from "utils/constants";
import { UserProvider } from "contexts/v1/masterData/UserContext";
import { ScheduleProvider } from "pages/hr/manage/context/ScheduleContext";
import { ShiftsProvider } from "pages/hr/master/context/ShiftsContext";
import { AttendanceProvider } from "contexts/v1/masterData/AttendanceContext";

// Import Tabs
import AttendanceHubRawTab from "./components/attendance-hub-raw-tab";
import AttendanceHubRecapTab from "./components/attendance-hub-recap-tab";
import AttendanceHubScheduleTab from "./components/attendance-hub-schedule-tab";

import "./attendance-recap-page.css";

const AttendanceHubPage = () => {
  const [activeTab, setActiveTab] = useState("raw");

  return (
    <LayoutHR>
      <div className="p-3">
        <div className="row align-items-center mb-4 g-3">
          <div className="col">
            <div className="text-muted small fw-bold text-uppercase ls-1 mb-1">HR Operations</div>
            <h1 className="m-0 fw-bold h2 d-flex align-items-center gap-2">
              <IconCalendarEvent size={28} className="text-primary" />
              Attendance Hub
            </h1>
            <div className="text-muted mt-1">Pusat pencatatan dan rekapitulasi absensi harian karyawan.</div>
          </div>
          <div className="col-auto">
            <Link to={URLS.v1.HR_MANAGE} className="btn btn-light border">
              <IconArrowLeft size={17} className="me-1" /> Kembali
            </Link>
          </div>
        </div>

        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header p-0">
            <ul className="nav nav-tabs card-header-tabs nav-fill m-0" style={{ borderBottom: "none" }}>
              <li className="nav-item">
                <button
                  className={`nav-link py-3 fw-medium ${activeTab === "raw" ? "active text-primary" : "text-muted"}`}
                  onClick={() => setActiveTab("raw")}
                  style={{ borderRadius: 0, borderTop: 0, borderLeft: 0, borderBottom: activeTab === "raw" ? "2px solid #206bc4" : "1px solid #e6e8eb" }}
                >
                  <IconListCheck size={18} className="me-2" />
                  Manajemen Absensi
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link py-3 fw-medium ${activeTab === "schedule" ? "active text-info" : "text-muted"}`}
                  onClick={() => setActiveTab("schedule")}
                  style={{ borderRadius: 0, borderTop: 0, borderBottom: activeTab === "schedule" ? "2px solid #4299e1" : "1px solid #e6e8eb" }}
                >
                  <IconCalendarEvent size={18} className="me-2" />
                  Manajemen Jadwal
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link py-3 fw-medium ${activeTab === "recap" ? "active text-success" : "text-muted"}`}
                  onClick={() => setActiveTab("recap")}
                  style={{ borderRadius: 0, borderTop: 0, borderRight: 0, borderBottom: activeTab === "recap" ? "2px solid #2fb344" : "1px solid #e6e8eb" }}
                >
                  <IconCalendarEvent size={18} className="me-2" />
                  Rekap Matriks
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        {/* We keep providers at this level so both tabs share filter context if possible, or they can have separate instances if needed. */}
        <UserProvider roleFilter="user_hr">
          <ShiftsProvider>
            <ScheduleProvider>
              <AttendanceProvider userRoleFilter="user_hr">
                {activeTab === "raw" && <AttendanceHubRawTab />}
                {activeTab === "schedule" && <AttendanceHubScheduleTab />}
                {activeTab === "recap" && <AttendanceHubRecapTab />}
              </AttendanceProvider>
            </ScheduleProvider>
          </ShiftsProvider>
        </UserProvider>
      </div>
    </LayoutHR>
  );
};

export default AttendanceHubPage;
